import React from 'react';
import { Grid } from 'antd';
import { useIntl } from 'react-intl';

const { useBreakpoint } = Grid;

interface ChatClosedPageProps {
  title?: string;
  message?: string;
  subMessage?: string;
}

const ChatClosedPage: React.FC<ChatClosedPageProps> = ({
  title,
  message,
  subMessage
}) => {
  const screens = useBreakpoint();
  const intl = useIntl();
  
  // 使用国际化文本作为默认值
  const defaultTitle = intl.formatMessage({ id: 'chat.closed.title' });
  const defaultMessage = intl.formatMessage({ id: 'chat.closed.message' });
  const defaultSubMessage = intl.formatMessage({ id: 'chat.closed.subMessage' });

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        padding: screens.xs ? '32px 24px' : '48px 32px',
        maxWidth: 380,
        width: '90%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
      }}>
        <svg width={screens.xs ? "48" : "64"} height={screens.xs ? "48" : "64"} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="32" fill="#FFF1F0"/>
          <path d="M24 28C24 25.7909 25.7909 24 28 24H36C38.2091 24 40 25.7909 40 28V36C40 38.2091 38.2091 40 36 40H28C25.7909 40 24 38.2091 24 36V28Z" fill="#FF4D4F"/>
          <rect x="29" y="32" width="6" height="2" rx="1" fill="white"/>
          <rect x="29" y="36" width="6" height="2" rx="1" fill="white"/>
        </svg>
        <h2 style={{ 
          color: '#ff4d4f', 
          fontWeight: 700, 
          fontSize: screens.xs ? '20px' : '24px', 
          margin: 0
        }}>
          {title || defaultTitle}
        </h2>
        <div style={{ 
          color: '#888', 
          fontSize: screens.xs ? '14px' : '16px', 
          marginBottom: 8,
          lineHeight: '1.5'
        }}>
          {message || defaultMessage}
        </div>
        <div style={{ 
          color: '#bfbfbf', 
          fontSize: screens.xs ? '12px' : '13px',
          lineHeight: '1.4'
        }}>
          {subMessage || defaultSubMessage}
        </div>
      </div>
    </div>
  );
};

export default ChatClosedPage; 